import React, { useEffect, useRef } from 'react';
import Button from '@material-ui/core/Button';
import { IconButton } from '@material-ui/core';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import CircularProgress from '@material-ui/core/CircularProgress';
import DateFnsUtils from '@date-io/date-fns';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import Cleave from 'cleave.js/react';
import {
  QuotationInput,
  QuotationInputMultiline,
} from '../../../components/FormInputs/FormInputs';
import Switch from '../../../components/Switch/Switch.jsx';
import LoadingIndicator from '../../../utils/LoadingIndicator/LoadingIndicator';
import Heading from '../../../components/Heading/Heading';
import axios from '../../../utils/Axios/axiosProxy';
import {
  chargeInputs,
  chargeObject,
  freightChargeObject,
  quotationImportantNotes,
  quotationOtherCharges,
  quotationRemarks,
} from '../../../utils/Data/dataTexts';
import { AdminDashboardContext } from '../AdminDashboard';
import {
  calcShipmentProperties,
  calcTotalShipmentWeightAndPcs,
  downloadPDF,
  uploadPDF,
} from '../../../utils/Functions/functions';
import QuotationForm from './PDFs/QuotationForm';

function Quotation({ ...props }) {
  const adminDashboardContext = React.useContext(AdminDashboardContext);
  const inputRef = useRef(null);
  const todaysDate = new Date().toISOString().split('T')[0];
  const [order, setOrder] = React.useState('');
  const [note, setNote] = React.useState('');
  const [quotation, setQuotation] = React.useState({
    reference: `${props.order._id.substring(props.order._id.length - 6)}`,
    validity: '',
    date: todaysDate,
    firstname: '',
    lastname: '',
    companyname: 'SKYU Global Forwarding Kft.',
    email: '',
    phone: '',
    servicelevel: '',
    carrier: '',
    via: '',
    transittime: '',
    incoterm: '',
    commodity: '',
    origincharges: [
      {
        chargename: '',
        unit: '',
        density: '',
        currency: '',
        rate: 0,
        total: 0,
      },
    ],
    totalorigincharges: 0,
    freightcharges: [
      {
        chargename: '',
        carrier: '',
        unit: '',
        density: '',
        currency: '',
        rate: 0,
        total: 0,
      },
    ],
    totalfreightcharges: 0,
    destinationcharges: [
      {
        chargename: '',
        unit: '',
        density: '',
        currency: '',
        rate: 0,
        total: 0,
      },
    ],
    totaldestinationcharges: 0,
    totalcharges: 0,
    currency: '',
    notes: [],
    othercharges: quotationOtherCharges,
    importantnotes: quotationImportantNotes,
    remarks: quotationRemarks,
  });
  const [loading, setLoading] = React.useState(true);
  const [sending, setSending] = React.useState(false);
  const [noti, setNoti] = React.useState('');

  useEffect(() => {
    setOrder(props.order);
    if (order.quotation) {
      order.quotation.notes = order.quotation.notes
        ? order.quotation.notes
        : [];
      order.quotation.othercharges = order.quotation.othercharges
        ? order.quotation.othercharges
        : quotationOtherCharges;
      order.quotation.importantnotes = order.quotation.importantnotes
        ? order.quotation.importantnotes
        : quotationImportantNotes;
      order.quotation.remarks = order.quotation.remarks
        ? order.quotation.remarks
        : quotationRemarks;
      order.quotation.reference =
        order.quotation.reference.length > 0
          ? order.quotation.reference
          : `${props.order._id.substring(props.order._id.length - 6)}`;
      setQuotation(order.quotation);
    }
    setLoading(false);
  }, [props.order, order.quotation, loading]);

  const addCommas = (num) => {
    if (num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  };

  const calcCharges = () => {
    let charges = {
      totalorigincharges: 0,
      totalfreightcharges: 0,
      totaldestinationcharges: 0,
      totalcharges: 0,
    };
    quotation['origincharges'].forEach((item) => {
      charges.totalorigincharges += parseFloat(item.total);
    });
    quotation['freightcharges'].forEach((item) => {
      charges.totalfreightcharges += parseFloat(item.total);
    });
    quotation['destinationcharges'].forEach((item) => {
      charges.totaldestinationcharges += parseFloat(item.total);
    });
    charges.totalcharges =
      charges.totalorigincharges +
      charges.totalfreightcharges +
      charges.totaldestinationcharges;
    setQuotation({
      ...quotation,
      totalcharges: charges.totalcharges,
      totalorigincharges: charges.totalorigincharges,
      totalfreightcharges: charges.totalfreightcharges,
      totaldestinationcharges: charges.totaldestinationcharges,
    });
  };

  const displayAddress = (addresses) => {
    let address = {
      city: '',
      address: '',
      postcode: '',
      country: '',
      companyname: '',
    };
    if (addresses.length > 0) {
      for (let i in addresses[0]) {
        address[i] = addresses[0][i];
      }
    }
    return address;
  };
  const handleChangeQuotation = (event) => {
    setQuotation({ ...quotation, [event.target.id]: event.target.value });
  };
  const handleChangeContact = (event) => {
    setOrder({
      ...order,
      contact: {
        ...order.contact,
        [event.target.id]: event.target.value,
      },
    });
  };
  const handleChangeOrder = (event) => {
    setOrder({ ...order, [event.target.id]: event.target.value });
  };
  const handleItemChange = (event, i, stateObj) => {
    let tempArray = order[stateObj];
    let tempItem = { ...tempArray[i] };
    tempItem[event.target.id] = event.target.value;
    if (
      stateObj === 'shipments' &&
      tempItem.height &&
      tempItem.height.length > 0 &&
      tempItem.width &&
      tempItem.width.length > 0 &&
      tempItem['length'] &&
      tempItem['length'].length > 0 &&
      tempItem.quantity &&
      tempItem.weight &&
      tempItem.weight.length > 0
    ) {
      tempItem = calcShipmentProperties(tempItem);
      tempArray[i] = tempItem;
      setOrder({
        ...order,
        [stateObj]: tempArray,
        shipmentweight: calcTotalShipmentWeightAndPcs(tempArray).shipmentweight,
        shipmentchargeableweight:
          calcTotalShipmentWeightAndPcs(tempArray).shipmentchargeableweight,
        shipmentpcs: calcTotalShipmentWeightAndPcs(tempArray).shipmentpcs,
        shipmentvolume: calcTotalShipmentWeightAndPcs(tempArray).shipmentvolume,
      });
    } else {
      tempArray[i] = tempItem;
      setOrder({ ...order, [stateObj]: tempArray });
    }
  };
  const addShipment = () => {
    let tempItem = order.shipments;
    tempItem.push({
      width: '',
      height: '',
      length: '',
      weight: '',
      quantity: '1',
      packaging: '',
      actualweight: 0,
      chargeableweight: 0,
      totalvolume: 0,
    });
    setOrder({ ...order, shipments: tempItem });
  };
  const removeShipment = () => {
    let index = order.shipments.length - 1;
    let tempItem = order.shipments;
    tempItem.splice(index, 1);
    setOrder({
      ...order,
      shipments: tempItem,
      shipmentweight: calcTotalShipmentWeightAndPcs(tempItem).shipmentweight,
      shipmentchargeableweight:
        calcTotalShipmentWeightAndPcs(tempItem).shipmentchargeableweight,
      shipmentpcs: calcTotalShipmentWeightAndPcs(tempItem).shipmentpcs,
      shipmentvolume: calcTotalShipmentWeightAndPcs(tempItem).shipmentvolume,
    });
    updateOrder({
      shipmentweight: calcTotalShipmentWeightAndPcs(tempItem).shipmentweight,
      shipmentchargeableweight:
        calcTotalShipmentWeightAndPcs(tempItem).shipmentchargeableweight,
      shipmentpcs: calcTotalShipmentWeightAndPcs(tempItem).shipmentpcs,
      shipmentvolume: calcTotalShipmentWeightAndPcs(tempItem).shipmentvolume,
    });
  };

  const handleChangeCharges = (value, id, chargeType, i) => {
    let tempArray = quotation[chargeType];
    let tempItem = { ...tempArray[i] };
    tempItem[id] = value;
    tempArray[i] = tempItem;
    setQuotation({
      ...quotation,
      [chargeType]: tempArray,
    });
    if (id === 'total') {
      calcCharges();
    }
  };
  const addCharges = (chargeType) => {
    let tempItem = quotation[chargeType];
    if (chargeType === 'freightcharges') {
      tempItem.push(freightChargeObject);
    } else tempItem.push(chargeObject);
    setQuotation({ ...quotation, [chargeType]: tempItem });
  };
  const removeCharges = (chargeType) => {
    let tempItem = quotation[chargeType];
    tempItem.splice(tempItem.length - 1, 1);
    setQuotation({ ...quotation, [chargeType]: tempItem });
  };
  const addNotes = () => {
    let tempItem = quotation.notes;
    tempItem.push(note);
    setQuotation({ ...quotation, notes: tempItem });
    setNote('');
    updateOrder();
  };
  const removeNotes = () => {
    let tempItem = quotation.notes;
    tempItem.splice(tempItem.length - 1, 1);
    setQuotation({ ...quotation, notes: tempItem });
    updateOrder();
  };
  const handleOtherRemarksChange = (event, topic, topicArray, i) => {
    let tempArray = topicArray;
    let tempItem = tempArray[i];
    tempItem.content = event.target.value;
    tempArray[i] = tempItem;
    setQuotation({ ...quotation, [topic]: tempArray });
  };
  const updateOrder = (params) => {
    let data = {
      orderID: order._id,
      updateParams: {
        ...order,
        quotation: quotation,
        ...params,
      },
    };
    axios
      .patch('/api/order/update', data, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        adminDashboardContext.getOrdersFromDB(localStorage.getItem('JWT'));
        console.log('UPDATE ORDER RESPONSE: ', response.statusText);
      })
      .catch((error) => {
        console.log('UPDATE ORDER ERROR: ', error);
      })
      .catch((error) => console.log('UPDATE ORDER CLIENT ERROR', error));
  };
  const sendQuotation = (data) => {
    setNoti(<p style={{ color: '#3f51b5' }}>Sending ...</p>);
    setSending(true);
    let status = order.proposalstatus === '' ? 'open' : order.proposalstatus;
    let formData = new FormData();
    formData.append('pdf', data);
    formData.append('orderID', order._id);
    formData.append('proposalstatus', status);
    formData.append('quotesent', true);
    axios
      .post('/api/order/quotation', formData, {
        headers: {
          'Content-Type': 'application/pdf',
        },
      })
      .then((response) => {
        adminDashboardContext.getOrdersFromDB(localStorage.getItem('JWT'));
        setNoti(<p style={{ color: '#1cb71c' }}>Quotation sent!</p>);
        setSending(false);
        console.log('SEND QUOTATION RESPONSE: ', response.statusText);
      })
      .catch((error) => {
        console.log('SEND QUOTATION ERROR: ', error);
        setNoti('Sending error, try again!');
        setSending(false);
      })
      .catch((error) => console.log('SEND QUOTATION CLIENT ERROR', error));
  };
  return (
    <>
      {loading ? (
        <LoadingIndicator />
      ) : (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <div>
            <div className='FlexCenter' style={{ width: '100%' }}>
              <div style={{ width: '1000px' }}>
                <Heading title='Quotation' />
                <div className='QuotaionContainer'>
                  <div className='QuotationBlock'>
                    <div className='QutotationRow'>
                      <div className='RowItem'>
                        <p>Quote Reference</p>
                      </div>
                      <div className='RowItem'>
                        <QuotationInput
                          id='reference'
                          value={quotation.reference}
                          onChange={(event) => handleChangeQuotation(event)}
                          onBlur={() => {
                            updateOrder();
                          }}
                        />
                      </div>
                      <div className='RowItem'>
                        <p>Quote Validity</p>
                      </div>
                      <div className='RowItem'>
                        <Cleave
                          id='validity'
                          value={quotation.validity}
                          onChange={(event) => handleChangeQuotation(event)}
                          onBlur={() => {
                            updateOrder();
                          }}
                          options={{
                            blocks: [4, 2, 2],
                            delimiter: '-',
                            numericOnly: false,
                          }}
                          className='QuotationInput'
                        />
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowItem'>
                        <p>Date of Quote</p>
                      </div>
                      <div className='RowItem' style={{ flex: '3' }}>
                        <Cleave
                          id='date'
                          value={quotation.date}
                          onChange={(event) => handleChangeQuotation(event)}
                          onBlur={() => {
                            updateOrder();
                          }}
                          options={{
                            blocks: [4, 2, 2],
                            delimiter: '-',
                            numericOnly: false,
                          }}
                          className='QuotationInput'
                        />
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowItem'>
                        <p>Customer </p>
                      </div>
                      <div className='RowItem' style={{ flex: '1' }}>
                        <QuotationInput
                          onChange={(event) => {
                            handleChangeContact(event);
                          }}
                          onBlur={() => {
                            updateOrder();
                          }}
                          id='firstname'
                          placeholder='First Name / Keresztnév'
                          value={order.contact.firstname}
                        />
                      </div>
                      <div className='RowItem' style={{ flex: '2' }}>
                        <QuotationInput
                          onChange={(event) => {
                            handleChangeContact(event);
                          }}
                          onBlur={() => {
                            updateOrder();
                          }}
                          id='lastname'
                          placeholder='Last Name / Vezetéknév'
                          value={order.contact.lastname}
                        />
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowItem'></div>
                      <div className='RowItem' style={{ flex: '1' }}>
                        <QuotationInput
                          placeholder='Company Name'
                          id='companyname'
                          value={order.contact.companyname}
                          onChange={(event) => {
                            handleChangeContact(event);
                          }}
                          onBlur={() => {
                            updateOrder();
                          }}
                        />
                      </div>
                      <div className='RowItem' style={{ flex: '2' }}>
                        <QuotationInput
                          placeholder='Tax Number'
                          onChange={(event) => {
                            handleChangeContact(event);
                          }}
                          onBlur={() => {
                            updateOrder();
                          }}
                          id='taxnr'
                          value={order.contact.taxnr}
                        />
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowItem'></div>
                      <div className='RowItem' style={{ flex: '3' }}>
                        <QuotationInput
                          id='email'
                          onChange={(event) => {
                            handleChangeContact(event);
                          }}
                          onBlur={() => {
                            updateOrder();
                          }}
                          placeholder='Email'
                          value={order.contact.email}
                        />
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowItem'></div>
                      <div className='RowItem' style={{ flex: '3' }}>
                        <QuotationInput
                          id='phone'
                          onChange={(event) => {
                            handleChangeContact(event);
                          }}
                          onBlur={() => {
                            updateOrder();
                          }}
                          placeholder='Phone'
                          value={order.contact.phone}
                        />
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowItem'>
                        <p>Quotation made by</p>
                      </div>
                      <div className='RowItem' style={{ flex: '1' }}>
                        <QuotationInput
                          placeholder='First Name'
                          id='firstname'
                          value={quotation.firstname}
                          onChange={(event) => handleChangeQuotation(event)}
                          onBlur={() => {
                            updateOrder();
                          }}
                        />
                      </div>
                      <div className='RowItem' style={{ flex: '2' }}>
                        <QuotationInput
                          placeholder='Last Name'
                          id='lastname'
                          value={quotation.lastname}
                          onChange={(event) => handleChangeQuotation(event)}
                          onBlur={() => {
                            updateOrder();
                          }}
                        />
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowItem'></div>
                      <div className='RowItem' style={{ flex: '3' }}>
                        <QuotationInput
                          placeholder='Company Name'
                          id='companyname'
                          value={quotation.companyname}
                          onChange={(event) => handleChangeQuotation(event)}
                          onBlur={() => {
                            updateOrder();
                          }}
                        />
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowItem'></div>
                      <div className='RowItem' style={{ flex: '3' }}>
                        <QuotationInput
                          placeholder='Email'
                          id='email'
                          value={quotation.email}
                          onChange={(event) => handleChangeQuotation(event)}
                          onBlur={() => {
                            updateOrder();
                          }}
                        />
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowItem'></div>
                      <div
                        className='RowItem'
                        style={{ flex: '3', paddingBottom: '8px' }}
                      >
                        <QuotationInput
                          placeholder='Phone'
                          id='phone'
                          value={quotation.phone}
                          onChange={(event) => handleChangeQuotation(event)}
                          onBlur={() => {
                            updateOrder();
                          }}
                        />
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowDivider'>
                        <p>Service information</p>
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowItem'>
                        <p>
                          Do you need offer for regular shipments or you need a
                          quotation for one shipment now?
                        </p>
                      </div>
                      <div
                        className='RowItem'
                        style={{ flex: '2', paddingTop: '8px' }}
                      >
                        <Switch
                          name='recurring'
                          id='regular'
                          word1='Yes'
                          word2='No'
                          checked={order.regular}
                          onChange={(event) => {
                            setOrder({
                              ...order,
                              [event.target.id]: event.target.checked,
                            });
                            updateOrder({
                              [event.target.id]: event.target.checked,
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowItem'>
                        <p>How often do you need to ship something?</p>
                      </div>
                      <div className='RowItem' style={{ flex: '2' }}>
                        <QuotationInput
                          onChange={(event) => {
                            handleChangeOrder(event);
                          }}
                          onBlur={() => {
                            updateOrder();
                          }}
                          id='frequency'
                          value={order.frequency}
                        />
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowItem'>
                        <p>What's your transit time requirement?</p>
                      </div>
                      <div className='RowItem' style={{ flex: '2' }}>
                        <QuotationInput
                          onChange={(event) => {
                            handleChangeOrder(event);
                          }}
                          onBlur={() => {
                            updateOrder();
                          }}
                          id='transittime'
                          value={order.transittime}
                        />
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowItem'>
                        <p>What's your estimated shipment ready date?</p>
                      </div>
                      <div className='RowItem' style={{ flex: '2' }}>
                        <KeyboardDatePicker
                          style={{
                            background: 'rgba(255, 255, 255, 0.8)',
                            width: '96%',
                            borderRadius: '3px',
                            padding: '12px',
                          }}
                          margin='normal'
                          id='date-picker-dialog'
                          label=''
                          format='yyyy/MM/dd'
                          value={order.shipmentready}
                          onChange={(date) => {
                            setOrder({ ...order, shipmentready: date });
                            updateOrder({ shipmentready: date });
                          }}
                          autoOk={true}
                          KeyboardButtonProps={{
                            'aria-label': 'change date',
                          }}
                        />
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowItem'>
                        <p>Do you have any special request?</p>
                      </div>
                      <div
                        className='RowItem'
                        style={{ flex: '2', paddingBottom: '8px' }}
                      >
                        <QuotationInputMultiline
                          onChange={(event) => {
                            handleChangeOrder(event);
                          }}
                          onBlur={() => {
                            updateOrder();
                          }}
                          id='specialreq'
                          value={order.specialreq}
                        />
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div
                        className='RowDivider'
                        style={{ height: '20px' }}
                      ></div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowItem'>
                        <p>Service Level</p>
                      </div>
                      <div className='RowItem'>
                        <p>Carrier</p>
                      </div>
                      <div className='RowItem'>
                        <p>Via</p>
                      </div>
                      <div className='RowItem'>
                        <p>Transit Time</p>
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowItem' style={{ paddingBottom: '8px' }}>
                        <QuotationInputMultiline
                          id='servicelevel'
                          value={quotation.servicelevel}
                          onChange={(event) => handleChangeQuotation(event)}
                          onBlur={() => {
                            updateOrder();
                          }}
                        />
                      </div>
                      <div className='RowItem' style={{ paddingBottom: '8px' }}>
                        <QuotationInputMultiline
                          id='carrier'
                          value={quotation.carrier}
                          onChange={(event) => handleChangeQuotation(event)}
                          onBlur={() => {
                            updateOrder();
                          }}
                        />
                      </div>
                      <div className='RowItem' style={{ paddingBottom: '8px' }}>
                        <QuotationInputMultiline
                          id='via'
                          value={quotation.via}
                          onChange={(event) => handleChangeQuotation(event)}
                          onBlur={() => {
                            updateOrder();
                          }}
                        />
                      </div>
                      <div className='RowItem' style={{ paddingBottom: '8px' }}>
                        <QuotationInputMultiline
                          id='transittime'
                          value={quotation.transittime}
                          onChange={(event) => handleChangeQuotation(event)}
                          onBlur={() => {
                            updateOrder();
                          }}
                        />
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div
                        className='RowDivider'
                        style={{ height: '20px' }}
                      ></div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowItem'>
                        <p>Would you like pickup from shipper to airport?</p>
                      </div>
                      <div className='RowItem' style={{ flex: '2' }}>
                        <Switch
                          name='pickup'
                          id='pickup'
                          word1='Yes'
                          word2='No'
                          checked={order.pickup}
                          onChange={(event) => {
                            setOrder({
                              ...order,
                              [event.target.id]: event.target.checked,
                            });
                            updateOrder({
                              [event.target.id]: event.target.checked,
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowItem'>
                        <p>What is the shipper's address</p>
                      </div>
                      <div className='RowItem' style={{ flex: '1' }}>
                        <QuotationInput
                          onChange={(event) => {
                            handleItemChange(event, 0, 'shipperaddresses');
                          }}
                          onBlur={() => {
                            updateOrder();
                          }}
                          id='city'
                          placeholder='City'
                          value={displayAddress(order.shipperaddresses).city}
                        />
                      </div>
                      <div className='RowItem' style={{ flex: '1' }}>
                        <QuotationInput
                          onChange={(event) => {
                            handleItemChange(event, 0, 'shipperaddresses');
                          }}
                          onBlur={() => {
                            updateOrder();
                          }}
                          id='postcode'
                          placeholder='Postcode'
                          value={
                            displayAddress(order.shipperaddresses).postcode
                          }
                        />
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowItem'></div>
                      <div className='RowItem' style={{ flex: '2' }}>
                        <QuotationInput
                          onChange={(event) => {
                            handleItemChange(event, 0, 'shipperaddresses');
                          }}
                          onBlur={() => {
                            updateOrder();
                          }}
                          id='address'
                          placeholder='Address'
                          value={displayAddress(order.shipperaddresses).address}
                        />
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowItem'>
                        <p>What is your preferred airport origin?</p>
                      </div>
                      <div className='RowItem' style={{ flex: '2' }}>
                        <QuotationInput
                          onChange={(event) => {
                            handleChangeOrder(event);
                          }}
                          onBlur={() => {
                            updateOrder();
                          }}
                          id='origin'
                          placeholder='Origin Airport'
                          value={order.origin}
                        />
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowItem'>
                        <p>What is your preferred destination airport?</p>
                      </div>
                      <div className='RowItem' style={{ flex: '2' }}>
                        <QuotationInput
                          onChange={(event) => {
                            handleChangeOrder(event);
                          }}
                          onBlur={() => {
                            updateOrder();
                          }}
                          id='destination'
                          placeholder='Destination Airport'
                          value={order.destination}
                        />
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowItem'>
                        <p>
                          Would you like delivery from destination to airport to
                          consignee address?
                        </p>
                      </div>
                      <div className='RowItem' style={{ flex: '2' }}>
                        <Switch
                          name='delivery'
                          id='delivery'
                          word1='Yes'
                          word2='No'
                          checked={order.delivery}
                          onChange={(event) => {
                            setOrder({
                              ...order,
                              [event.target.id]: event.target.checked,
                            });
                            updateOrder({
                              [event.target.id]: event.target.checked,
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowItem'>
                        <p>What's the consignee address</p>
                      </div>
                      <div className='RowItem' style={{ flex: '1' }}>
                        <QuotationInput
                          placeholder='City'
                          id='city'
                          onChange={(event) => {
                            handleItemChange(event, 0, 'consigneeaddresses');
                          }}
                          onBlur={() => {
                            updateOrder();
                          }}
                          value={displayAddress(order.consigneeaddresses).city}
                        />
                      </div>
                      <div className='RowItem' style={{ flex: '1' }}>
                        <QuotationInput
                          placeholder='Postcode'
                          id='postcoder'
                          onChange={(event) => {
                            handleItemChange(event, 0, 'consigneeaddresses');
                          }}
                          onBlur={() => {
                            updateOrder();
                          }}
                          value={
                            displayAddress(order.consigneeaddresses).postcode
                          }
                        />
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowItem'></div>
                      <div className='RowItem' style={{ flex: '2' }}>
                        <QuotationInput
                          placeholder='Address'
                          id='address'
                          onChange={(event) => {
                            handleItemChange(event, 0, 'consigneeaddresses');
                          }}
                          onBlur={() => {
                            updateOrder();
                          }}
                          value={
                            displayAddress(order.consigneeaddresses).address
                          }
                        />
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowItem'>
                        <p>Incoterm</p>
                      </div>
                      <div className='RowItem' style={{ flex: '2' }}>
                        <QuotationInput
                          id='incoterm'
                          value={quotation.incoterm}
                          onChange={(event) => {
                            handleChangeQuotation(event);
                          }}
                          onBlur={() => {
                            updateOrder();
                          }}
                        />
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div
                        className='RowItem'
                        style={{
                          paddingBottom: '16px',
                        }}
                      >
                        <p>Commodity</p>
                      </div>
                      <div
                        className='RowItem'
                        style={{
                          flex: '2',
                          paddingBottom: '16px',
                        }}
                      >
                        <QuotationInput
                          id='commodity'
                          value={quotation.commodity}
                          onChange={(event) => {
                            handleChangeQuotation(event);
                          }}
                          onBlur={() => {
                            updateOrder();
                          }}
                        />
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowDivider'>
                        <p>Cargo Details</p>
                      </div>
                    </div>
                    {order.shipments.map((shipment, i) => {
                      return (
                        <>
                          <div className='QutotationRow'>
                            <div className='RowItem'>
                              <p>{`Package ${i + 1}`}</p>
                            </div>
                            <div className='RowItem'>
                              <p>Nr. of pcs</p>
                            </div>
                            <div className='RowItem'>
                              <p>Type of packaging</p>
                            </div>
                            <div className='RowItemDim' style={{ flex: '3' }}>
                              <p>Dimensions</p>
                              <div className='DimItem'>
                                <p className='Flex1'>Wi (cm)</p>
                                <p className='Flex1'>H (cm)</p>
                                <p className='Flex1'>L (cm)</p>
                                <p className='Flex1'>We (kg)</p>
                              </div>
                            </div>
                            <div className='RowItem'>
                              <p>Actual Weight</p>
                            </div>
                            <div className='RowItem'>
                              <p>Chargable Weight</p>
                            </div>
                            <div className='RowItem'>
                              <p>Total Volume in CBM</p>
                            </div>
                          </div>
                          <div className='QutotationRow'>
                            <div className='RowItem'>
                              <QuotationInput />
                            </div>
                            <div className='RowItem'>
                              <QuotationInput
                                value={shipment.quantity}
                                id='quantity'
                                onChange={(event) => {
                                  handleItemChange(event, i, 'shipments');
                                }}
                                onBlur={() => {
                                  updateOrder();
                                }}
                              />
                            </div>
                            <div className='RowItem'>
                              <QuotationInput
                                id='packaging'
                                value={shipment.packaging}
                                onChange={(event) => {
                                  handleItemChange(event, i, 'shipments');
                                }}
                                onBlur={() => {
                                  updateOrder();
                                }}
                              />
                            </div>
                            <div className='RowItem' style={{ flex: '3' }}>
                              <QuotationInput
                                id='width'
                                value={shipment.width}
                                onChange={(event) => {
                                  handleItemChange(event, i, 'shipments');
                                }}
                                onBlur={() => {
                                  updateOrder();
                                }}
                              />
                              <QuotationInput
                                id='height'
                                value={shipment.height}
                                onChange={(event) => {
                                  handleItemChange(event, i, 'shipments');
                                }}
                                onBlur={() => {
                                  updateOrder();
                                }}
                              />
                              <QuotationInput
                                id='length'
                                value={shipment['length']}
                                onChange={(event) => {
                                  handleItemChange(event, i, 'shipments');
                                }}
                                onBlur={() => {
                                  updateOrder();
                                }}
                              />
                              <QuotationInput
                                id='weight'
                                value={shipment.weight}
                                onChange={(event) => {
                                  handleItemChange(event, i, 'shipments');
                                }}
                                onBlur={() => {
                                  updateOrder();
                                }}
                              />
                            </div>
                            <div className='RowItem'>
                              <QuotationInput
                                id='actualweight'
                                value={shipment.actualweight}
                              />
                            </div>
                            <div className='RowItem'>
                              <QuotationInput
                                id='chargeableweight'
                                value={shipment.chargeableweight}
                              />
                            </div>
                            <div className='RowItem'>
                              <QuotationInput
                                id='totalvolume'
                                value={shipment.totalvolume}
                              />
                            </div>
                          </div>
                        </>
                      );
                    })}
                    <div className='QutotationRow'>
                      <div className='RowDivider OrangeBg'>
                        <p style={{ flex: '1' }}>Total</p>
                        <p style={{ flex: '6' }}>
                          {`${order.shipmentpcs} pcs` || '0'}
                        </p>
                        <p style={{ flex: '1' }}>
                          {`${order.shipmentweight} kg` || '0'}
                        </p>
                        <p style={{ flex: '1' }}>
                          {`${order.shipmentchargeableweight} kg` || '0'}
                        </p>
                        <p style={{ flex: '1' }}>
                          {`${order.shipmentvolume}` || '0'}m<sup>3</sup>
                        </p>
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowDivider BottomBorder'>
                        <p style={{ flex: '1' }}>
                          <span
                            style={{
                              float: 'right',
                              marginRight: '12px',
                              color: 'black',
                            }}
                          >
                            <IconButton
                              onClick={() => addShipment()}
                              style={{
                                padding: '8px',
                              }}
                            >
                              <AddCircleOutlineIcon />
                            </IconButton>
                            <IconButton
                              onClick={() => {
                                removeShipment();
                              }}
                              style={{
                                padding: '8px',
                              }}
                            >
                              <RemoveCircleOutlineIcon />
                            </IconButton>
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowDivider'>
                        <p>Origin Charges</p>
                      </div>
                    </div>
                    {quotation.origincharges.map((item, i) => {
                      let firstRow = [];
                      let secondRow = [];
                      chargeInputs.forEach((input, index) => {
                        if (input.id !== 'carrier') {
                          firstRow.push(
                            <div className='RowItem'>
                              <p>{input.label}</p>
                            </div>
                          );
                          secondRow.push(
                            <div className='RowItem'>
                              <QuotationInput
                                number={input.id === 'total' ? true : false}
                                id={input.id}
                                value={item[input.id]}
                                onChange={(event) =>
                                  input.id === 'total'
                                    ? handleChangeCharges(
                                        event,
                                        input.id,
                                        'origincharges',
                                        i
                                      )
                                    : handleChangeCharges(
                                        event.target.value,
                                        event.target.id,
                                        'origincharges',
                                        i
                                      )
                                }
                                onBlur={() => {
                                  updateOrder();
                                }}
                              />
                            </div>
                          );
                        }
                      });
                      return i === 0 ? (
                        <>
                          <div className='QutotationRow'>{firstRow}</div>
                          <div className='QutotationRow'>{secondRow}</div>
                        </>
                      ) : (
                        <div className='QutotationRow'>{secondRow}</div>
                      );
                    })}
                    <div className='QutotationRow'>
                      <div className='RowDivider BottomBorder'>
                        <p style={{ flex: '1' }}>
                          <span
                            style={{
                              float: 'right',
                              marginRight: '12px',
                              color: 'black',
                            }}
                          >
                            <IconButton
                              onClick={() => addCharges('origincharges')}
                              style={{
                                padding: '8px',
                              }}
                            >
                              <AddCircleOutlineIcon />
                            </IconButton>
                            <IconButton
                              onClick={() => removeCharges('origincharges')}
                              style={{
                                padding: '8px',
                              }}
                            >
                              <RemoveCircleOutlineIcon />
                            </IconButton>
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowDivider BottomBorder'>
                        <p style={{ flex: '1' }}>
                          <span
                            style={{
                              float: 'right',
                              marginRight: '12px',
                              color: 'black',
                            }}
                          >
                            {`Total Origin Charges (${
                              quotation.origincharges[0].currency
                            }): ${
                              quotation.origincharges[0].currency
                                ? addCommas(quotation.totalorigincharges)
                                : 0
                            }`}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowDivider'>
                        <p>Freight Charges</p>
                      </div>
                    </div>
                    {quotation.freightcharges.map((item, i) => {
                      let firstRow = [];
                      let secondRow = [];
                      chargeInputs.forEach((input, index) => {
                        firstRow.push(
                          <div className='RowItem'>
                            <p>{input.label}</p>
                          </div>
                        );
                        secondRow.push(
                          <div className='RowItem'>
                            <QuotationInput
                              number={input.id === 'total' ? true : false}
                              id={input.id}
                              value={item[input.id]}
                              onChange={(event) =>
                                input.id === 'total'
                                  ? handleChangeCharges(
                                      event,
                                      input.id,
                                      'freightcharges',
                                      i
                                    )
                                  : handleChangeCharges(
                                      event.target.value,
                                      event.target.id,
                                      'freightcharges',
                                      i
                                    )
                              }
                              onBlur={() => {
                                updateOrder();
                              }}
                            />
                          </div>
                        );
                      });
                      return i === 0 ? (
                        <>
                          <div className='QutotationRow'>{firstRow}</div>
                          <div className='QutotationRow'>{secondRow}</div>
                        </>
                      ) : (
                        <div className='QutotationRow'>{secondRow}</div>
                      );
                    })}
                    <div className='RowDivider BottomBorder'>
                      <p style={{ flex: '1' }}>
                        <span
                          style={{
                            float: 'right',
                            marginRight: '12px',
                            color: 'black',
                          }}
                        >
                          <IconButton
                            onClick={() => addCharges('freightcharges')}
                            style={{
                              padding: '8px',
                            }}
                          >
                            <AddCircleOutlineIcon />
                          </IconButton>
                          <IconButton
                            onClick={() => removeCharges('freightcharges')}
                            style={{
                              padding: '8px',
                            }}
                          >
                            <RemoveCircleOutlineIcon />
                          </IconButton>
                        </span>
                      </p>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowDivider BottomBorder'>
                        <p style={{ flex: '1' }}>
                          <span
                            style={{
                              float: 'right',
                              marginRight: '12px',
                              color: 'black',
                            }}
                          >
                            {`Total Freight Charges (${
                              quotation.freightcharges[0].currency
                            }): ${
                              quotation.freightcharges[0].currency
                                ? addCommas(quotation.totalfreightcharges)
                                : 0
                            }`}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowDivider'>
                        <p>Destination Charges</p>
                      </div>
                    </div>
                    {quotation.destinationcharges.map((item, i) => {
                      let firstRow = [];
                      let secondRow = [];
                      chargeInputs.forEach((input, index) => {
                        if (input.id !== 'carrier') {
                          firstRow.push(
                            <div className='RowItem'>
                              <p>{input.label}</p>
                            </div>
                          );
                          secondRow.push(
                            <div className='RowItem'>
                              <QuotationInput
                                number={input.id === 'total' ? true : false}
                                id={input.id}
                                value={item[input.id]}
                                onChange={(event) =>
                                  input.id === 'total'
                                    ? handleChangeCharges(
                                        event,
                                        input.id,
                                        'destinationcharges',
                                        i
                                      )
                                    : handleChangeCharges(
                                        event.target.value,
                                        event.target.id,
                                        'destinationcharges',
                                        i
                                      )
                                }
                                onBlur={() => {
                                  updateOrder();
                                }}
                              />
                            </div>
                          );
                        }
                      });
                      return i === 0 ? (
                        <>
                          <div className='QutotationRow'>{firstRow}</div>
                          <div className='QutotationRow'>{secondRow}</div>
                        </>
                      ) : (
                        <div className='QutotationRow'>{secondRow}</div>
                      );
                    })}
                    <div className='RowDivider BottomBorder'>
                      <p style={{ flex: '1' }}>
                        <span
                          style={{
                            float: 'right',
                            marginRight: '12px',
                            color: 'black',
                          }}
                        >
                          <IconButton
                            onClick={() => addCharges('destinationcharges')}
                            style={{
                              padding: '8px',
                            }}
                          >
                            <AddCircleOutlineIcon />
                          </IconButton>
                          <IconButton
                            onClick={() => removeCharges('destinationcharges')}
                            style={{
                              padding: '8px',
                            }}
                          >
                            <RemoveCircleOutlineIcon />
                          </IconButton>
                        </span>
                      </p>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowDivider BottomBorder'>
                        <p style={{ flex: '1' }}>
                          <span
                            style={{
                              float: 'right',
                              marginRight: '12px',
                              color: 'black',
                            }}
                          >
                            {`Total Destination Charges (${
                              quotation.destinationcharges[0].currency
                            }): ${
                              quotation.destinationcharges[0].currency
                                ? addCommas(quotation.totaldestinationcharges)
                                : 0
                            }`}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowDivider'>
                        <p style={{ flex: '3' }}>Total Quotation Charges</p>
                        <p style={{ flex: '1' }}>Currency</p>
                        <p style={{ flex: '2' }}>Price</p>
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowItem Total' style={{ flex: 3 }}>
                        <p>Total Origin Charges</p>
                      </div>
                      <div className='RowItem Total'>
                        <p>{`${quotation.origincharges[0].currency}`}</p>
                      </div>
                      <div className='RowItem Total' style={{ flex: 2 }}>
                        <p>{addCommas(quotation.totalorigincharges)}</p>
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowItem Total' style={{ flex: 3 }}>
                        <p>Total Freight Charges</p>
                      </div>
                      <div className='RowItem Total'>
                        <p>{`${quotation.freightcharges[0].currency}`}</p>
                      </div>
                      <div className='RowItem Total' style={{ flex: 2 }}>
                        <p>{addCommas(quotation.totalfreightcharges)}</p>
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowItem Total' style={{ flex: 3 }}>
                        <p>Total Destination Charges</p>
                      </div>
                      <div className='RowItem Total'>
                        <p>{`${quotation.destinationcharges[0].currency}`}</p>
                      </div>
                      <div className='RowItem Total' style={{ flex: 2 }}>
                        <p>{addCommas(quotation.totaldestinationcharges)}</p>
                      </div>
                    </div>
                    <div className='QutotationRow'>
                      <div
                        className='RowDivider'
                        style={{ height: '20px' }}
                      ></div>
                    </div>
                    <div className='QutotationRow'>
                      <div className='RowItem OrangeBg' style={{ flex: 3 }}>
                        <p>TOTAL</p>
                      </div>
                      <div className='RowItem OrangeBg'>
                        <QuotationInput
                          id='currency'
                          placeholder='Currency'
                          className='QuotationInputOrange' /* value={shipment.quantity} */
                          onChange={(event) => {
                            setQuotation({
                              ...quotation,
                              currency: event.target.value,
                            });
                          }}
                          value={quotation.currency || ''}
                          onBlur={() => {
                            updateOrder();
                          }}
                        />
                      </div>
                      <div className='RowItem OrangeBg' style={{ flex: 2 }}>
                        <QuotationInput
                          number={true}
                          id='totalcharges'
                          placeholder='Total Price'
                          className='QuotationInputOrange' /* value={shipment.quantity} */
                          onChange={(event) => {
                            setQuotation({
                              ...quotation,
                              totalcharges: event,
                            });
                          }}
                          value={quotation.totalcharges}
                          onBlur={() => {
                            updateOrder();
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className='QutotationRow'>
                  <div className='RowItem'>
                    <p>{`Egyéb esetlegesen felmerülő költségek /Other charges if occur`}</p>
                  </div>
                </div>
                {quotation.othercharges.map((item, i) => {
                  return (
                    <>
                      <div className='QutotationRow'>
                        <div className='RowItem'>
                          <p>{item.label}</p>
                        </div>
                      </div>
                      <div className='QutotationRow'>
                        <div className='RowItem'>
                          <QuotationInput
                            onChange={(event) => {
                              handleOtherRemarksChange(
                                event,
                                'othercharges',
                                quotation.othercharges,
                                i
                              );
                            }}
                            value={quotation.othercharges[i].content}
                            onBlur={updateOrder}
                          />
                        </div>
                      </div>
                    </>
                  );
                })}
                <div className='QutotationRow'>
                  <div className='RowItem'>
                    <p>{`Fontos megjegyzések`}</p>
                  </div>
                </div>
                {quotation.importantnotes.map((item, i) => {
                  return (
                    <>
                      <div className='QutotationRow'>
                        <div className='RowItem'>
                          <QuotationInput
                            onChange={(event) => {
                              handleOtherRemarksChange(
                                event,
                                'importantnotes',
                                quotation.importantnotes,
                                i
                              );
                            }}
                            value={quotation.importantnotes[i].content}
                            onBlur={updateOrder}
                          />
                        </div>
                      </div>
                    </>
                  );
                })}
                <div className='QutotationRow'>
                  <div className='RowItem'>
                    <p>{`Remarks`}</p>
                  </div>
                </div>
                {quotation.remarks.map((item, i) => {
                  return (
                    <>
                      <div className='QutotationRow'>
                        <div className='RowItem'>
                          <QuotationInput
                            onChange={(event) => {
                              handleOtherRemarksChange(
                                event,
                                'remarks',
                                quotation.remarks,
                                i
                              );
                            }}
                            onBlur={updateOrder}
                            value={quotation.remarks[i].content}
                          />
                        </div>
                      </div>
                    </>
                  );
                })}
                <div className='QutotationRow'>
                  <div className='RowItem'>
                    <p>{`Notes`}</p>
                  </div>
                </div>
                {quotation.notes.length > 0 ? (
                  quotation.notes.map((note, i) => {
                    return (
                      <>
                        <div className='QutotationRow'>
                          <div className='RowItem'>
                            <QuotationInput
                              placeholder='Notes'
                              value={note}
                              disabled
                            />
                          </div>
                        </div>
                      </>
                    );
                  })
                ) : (
                  <></>
                )}
                <div className='QutotationRow'>
                  <div className='RowItem'>
                    <p>{`New Note`}</p>
                  </div>
                </div>
                <div className='QutotationRow'>
                  <div className='RowItem'>
                    <QuotationInput
                      placeholder='Notes'
                      onChange={(event) => {
                        setNote(event.target.value);
                      }}
                      value={note}
                    />
                  </div>
                </div>
                <div className='QutotationRow'>
                  <div className='RowDivider BottomBorder'>
                    <p style={{ flex: '1' }}>
                      <span
                        style={{
                          float: 'right',
                          marginRight: '12px',
                          color: 'black',
                        }}
                      >
                        <IconButton
                          onClick={() => addNotes()}
                          style={{
                            padding: '8px',
                          }}
                        >
                          <AddCircleOutlineIcon />
                        </IconButton>
                        <IconButton
                          onClick={() => {
                            if (quotation.notes.length > 0) {
                              removeNotes();
                            }
                          }}
                          style={{
                            padding: '8px',
                          }}
                        >
                          <RemoveCircleOutlineIcon />
                        </IconButton>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className='Row Margin' style={{ justifyContent: 'flex-end' }}>
              <>
                {sending ? (
                  <div
                    className='Column Margin FlexCenter'
                    style={{ width: '285px', alignSelf: 'flex-end' }}
                  >
                    <CircularProgress />
                    {noti}
                  </div>
                ) : (
                  <>
                    <Button
                      className='ToreaBay Small MarginSides'
                      onClick={() => {
                        updateOrder();
                      }}
                    >
                      Save
                    </Button>
                    <Button
                      className='ToreaBay Small MarginSides'
                      onClick={async () => {
                        await updateOrder();
                        uploadPDF(sendQuotation);
                      }}
                    >
                      Send
                    </Button>
                    <Button
                      className='ToreaBay Small MarginSides'
                      onClick={() => downloadPDF(order._id)}
                    >
                      Download
                    </Button>
                  </>
                )}
              </>
            </div>
            {sending ? null : (
              <div
                className='Row Margin'
                style={{
                  width: '90%',
                  alignSelf: 'flex-end',
                  display: 'flex',
                  alignItems: 'flex-end',
                  justifyContent: 'flex-end',
                }}
              >
                {noti}
              </div>
            )}
            <div className='FlexCenter'>
              <div id='divToPrint' ref={inputRef} style={{ width: '800px' }}>
                <QuotationForm order={order} quotation={quotation} />
              </div>
            </div>
          </div>
        </MuiPickersUtilsProvider>
      )}
    </>
  );
}

export default Quotation;
